/**
 * Created by dimah on 18/06/17.
 */

import {inject, Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpXsrfTokenExtractor } from '@angular/common/http';

import {Observable, throwError} from 'rxjs';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {tap} from "rxjs/operators";
import {LoginService} from "./login";

/** Pass untouched request through to the next request handler. */
@Injectable()
export class NoopInterceptor implements HttpInterceptor {

    loginService: LoginService = inject(LoginService);
    constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const cookieHeaderName = 'X-XSRF-TOKEN';
        let request = req.clone({withCredentials: true});
        // skip token in 'LoginRouteInSignatureEnv' fix the CORS error caused by the X-XSRF-TOKEN cookie set from another signature environment site using the same subdomain.
        if (req.method !== 'GET' && req.method !== 'HEAD' && !this.loginService.isLoginRouteInSignatureEnv(req.url)) {
            // default cookie name is XSRF-TOKEN
            const token = this.tokenExtractor.getToken();
            if (token !== null && !req.headers.has(cookieHeaderName)) {
                request = request.clone({headers: req.headers.set(cookieHeaderName, token)});
            }
        }
        return next.handle(request)
            .pipe(tap(
                () => {},
                (error: any) => {
                    if(error instanceof HttpErrorResponse) {
                        if (error.error instanceof Object && error.error['redirectToLogin']) {
                            window.location.href = '/login';
                        } else {
                            throwError(error);
                        }
                    }
                }
            ));
    }

}
export const RequestOptionsProvider = [
    { provide: HTTP_INTERCEPTORS, useClass: NoopInterceptor, multi: true },
];
